(String.prototype.format = String.prototype.f = function () {
  for (var a = this, b = arguments.length; b--; )
    a = a.replace(new RegExp("\\{" + b + "\\}", "gm"), arguments[b]);
  return a;
}),
  $(document).ready(function () {
    function g(e, f, g, h) {
      var k = 864e5,
        l = new Date(e.getFullYear(), e.getMonth(), 1),
        n = new Date(e.getFullYear(), e.getMonth() + h, 2),
        o = e,
        p = e;
      for (a = [], b = [], d = [], c = []; l < p; ) p = new Date(p - f * k);
      for (; o < n; ) {
        var q = Date.parse(p);
        o = new Date(q + f * k);
        for (var r = 1; r <= 2; r++) {
          var s = q - r * k;
          b.push(new Date(s).toDateString());
        }
        for (var r = 0; r < g; r++) {
          var s = q + r * k;
          a.push(new Date(s).toDateString());
        }
        for (var r = 0; r < 2; r++) {
          var s = q + (g + r) * k;
          d.push(new Date(s).toDateString());
        }
        for (var r = 0; r < 5; r++) {
          var s = q + (10 + r) * k;
          c.push(new Date(s).toDateString());
        }
        p = o;
      }
      for (var r = 0; r < 2 * g; r++) {
        if (r == g) var t = new Date(a[r]);
        if (r == 2 * g - 1) var u = new Date(a[r]);
      }
      $(".pc-add-to-cal").empty(), m(t, u), i(e, h);
    }
    function h(a) {
      var b = $("div#datepicker").datepicker("getDate"),
        c = parseInt($("#cycleLen").text(), 10),
        d = parseInt($("#duration").text(), 10),
        e = 864e5,
        f = new Date(),
        h = b;
      if (a > 0)
        for (f = new Date(b.getFullYear(), b.getMonth() + a, 2); f > h; )
          h = new Date(Date.parse(h) + c * e);
      else {
        for (f = new Date(b.getFullYear(), b.getMonth() + a + 1, 0); f <= h; )
          h = new Date(Date.parse(h) - c * e);
        a = -a;
      }
      $("div#datepicker").datepicker("setDate", h), g(h, c, d, a);
    }
    function i(a, b) {
      $("#period_result_calender").datepicker("destroy"),
        $("#period_result_calender").datepicker({
          numberOfMonths: b,
          beforeShowDay: j,
          showOtherMonths: !0,
          selectOtherMonths: !1,
          defaultDate: a
        }),
        e
          ? ($("#period_result_calender .ui-corner-all").off("click"),
            $("#period_result_calender .ui-datepicker-prev").on(
              "click",
              function () {
                $(".previous_result").click();
              }
            ),
            $("#period_result_calender .ui-datepicker-next").on(
              "click",
              function () {
                $(".next_result").click();
              }
            ))
          : ($("#period_result_calender .ui-datepicker-prev").on(
              "click",
              function () {
                $(".previous_result").click();
              }
            ),
            $("#period_result_calender .ui-datepicker-next").on(
              "click",
              function () {
                $(".next_result").click();
              }
            )),
        $("#period_result_calender .ui-datepicker-today").removeClass(
          "ui-datepicker-today"
        ),
        $("#period_result_calender .ui-datepicker-current-day").removeClass(
          "ui-datepicker-current-day"
        ),
        $(".period_legends").show(),
        $("#calsection").show(),
        $(".period_details div").hide();
      var c = "";
      e
        ? (c = "click")
        : ((c = "mouseover click"), $(".periodDays_detail").show()),
        $(".period_results a").on(c, function (a) {
          a.preventDefault(), a.stopPropagation();
          var b = $(
            "." + $(this).parent().attr("class").split(" ").pop() + "_detail"
          );
          b.length &&
            (e ||
              ($(".period_details").css("height", $(b).css("height")),
              $(".period_details").css("margin-top", $(b).css("margin-top"))),
            $(".period_details div").hide(),
            $(b).show());
        });
    }
    function j(e) {
      var f = e.toDateString();
      return $.inArray(f, a) > -1
        ? [!0, "period-days", "Jour de rÃ¨gles"]
        : $.inArray(f, b) > -1
        ? [!0, "pre-period", "Jour avant les rÃ¨gles"]
        : $.inArray(f, d) > -1
        ? [!0, "post-period", "Jour aprÃ¨s les rÃ¨gles"]
        : $.inArray(f, c) > -1
        ? [!0, "peak-ovulation", "Pic dâ€™ovulation"]
        : [!0, ""];
    }
    function m(a, b) {
      var c = createCalendar({
        options: { class: "", id: "my-id" },
        data: {
          title: "Period Days",
          start: new Date(a),
          duration: 120,
          end: new Date(b),
          address: "",
          description: "Period Days"
        }
      });
      document.querySelector(".pc-add-to-cal").appendChild(c);
    }
    var a = [],
      b = [],
      c = [],
      d = [];
    $("#calsection").hide();
    var e = !1;
    /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
      navigator.userAgent
    ) &&
      $(window).width() < 767 &&
      (e = !0),
      $(window).width() < 1023 && (e = !0),
      $("div#datepicker").datepicker({
        dateFormat: "d M",
        showOtherMonths: !0,
        selectOtherMonths: !1,
        onSelect: function (a, b) {
          var c = a.split(" "),
            d = "";
          switch (b.selectedDay) {
            case "1":
            case "21":
            case "31":
              d = "st";
              break;
            case "2":
            case "22":
              d = "nd";
              break;
            case "3":
            case "23":
              d = "rd";
              break;
            default:
              d = "th";
          }
          var e = "<span>{0} {1}</span>".format(c[0], c[1]);
          $("#todaydate").html(e), $("div#datepicker").hide();
        }
      }),
      $(".ui-datepicker-today").click(),
      $("#selectdate").click(function (a) {
        a.stopPropagation(), $("div#datepicker").toggle();
      }),
      $("html").on("click", function () {
        $("div#datepicker").hide(),
          $(".fa-calendar").removeClass("icon_active");
      }),
      $("a.date-picker,div#datepicker").on("click", function (a) {
        a.preventDefault(), a.stopPropagation();
      }),
      $(".tracknow").click(function () {
        var a = e ? 1 : 3,
          b = $("div#datepicker").datepicker("getDate"),
          c = parseInt($("#cycleLen").text(), 10),
          d = parseInt($("#duration").text(), 10);
        g(b, c, d, a),
          $("html, body").animate(
            { scrollTop: $("#calsection").offset().top },
            1e3
          );
      }),
      $(".nextPrevious .previous_result").click(function () {
        var a = e ? -1 : -3;
        h(a);
      }),
      $(".nextPrevious .next_result").click(function () {
        var a = e ? 1 : 3;
        h(a);
      }),
      $("#printit, #pdfit ").on("click", function (a) {
        a.preventDefault(), a.stopPropagation(), window.print();
      });
  });
/* French initialisation for the jQuery UI date picker plugin. */
/* Written by Keith Wood (kbwood{at}iinet.com.au),
			  StÃ©phane Nahmani (sholby@sholby.net),
			  StÃ©phane Raimbault <stephane.raimbault@gmail.com> */
(function (factory) {
  if (typeof define === "function" && define.amd) {
    // AMD. Register as an anonymous module.
    define(["../widgets/datepicker"], factory);
  } else {
    // Browser globals
    factory(jQuery.datepicker);
  }
})(function (datepicker) {
  datepicker.regional.fr = {
    closeText: "Fermer",
    prevText: "PrÃ©cÃ©dent",
    nextText: "Suivant",
    currentText: "Aujourd'hui",
    monthNames: [
      "Janvier",
      "Février",
      "Mars",
      "Avril",
      "Mai",
      "Juin",
      "Juillet",
      "Août",
      "Septembre",
      "Octobre",
      "Novembre",
      "Décembre"
    ],
    monthNamesShort: [
      "Janv.",
      "Fév.",
      "Mars",
      "Avr.",
      "Mai",
      "Juin",
      "Juil.",
      "Aoû",
      "Sept.",
      "Oct.",
      "Nov.",
      "Déc."
    ],
    dayNames: [
      "Dimanche",
      "Lundi",
      "Mardi",
      "Mercredi",
      "Jeudi",
      "Vendredi",
      "Samedi"
    ],
    dayNamesShort: ["Dim.", "Lun.", "Mar.", "Mer.", "Jeu.", "Ven.", "Sam."],
    dayNamesMin: ["Di", "Lu", "Ma", "Me", "Je", "Ve", "Sa"],
    weekHeader: "Sem.",
    dateFormat: "dd/mm/yy",
    firstDay: 1,
    isRTL: false,
    showMonthAfterYear: false,
    yearSuffix: ""
  };
  datepicker.setDefaults(datepicker.regional.fr);
  return datepicker.regional.fr;
});
